module.exports = __webpack_public_path__ + "static/media/university-1.4b623768.png";